import {
  SERVICE_PLAN_FREE,
  SERVICE_PLAN_STANDARD,
  SERVICE_PLAN_NOTOPEN,
  SERVICE_PLAN_ARCHIVED
} from '@/constant/codmonPricing';

const normalizePlanId = (planId: number | string | null | undefined): number | null => {
  if (planId == null) return null;
  const parsed = typeof planId === 'string' ? parseInt(planId, 10) : planId;
  return isNaN(parsed) ? null : parsed;
};

const BASIC_SERVICE_PLANS = new Set([
  SERVICE_PLAN_FREE, // ややっこしいがFREEはデモ期間などの無料期間中のコドモンベーシックなので含める
  SERVICE_PLAN_STANDARD, // コドモンベーシック
  SERVICE_PLAN_NOTOPEN, // 開園前
  SERVICE_PLAN_ARCHIVED // データ保存
])

/**
 * 有料基本機能が含まれるベーシックプランかどうかを判定する
 *
 * 以下のプランの場合は false を返す
 * - SERVICE_PLAN_PHOTO（無料施設会員）
 * - SERVICE_PLAN_SUSPENDED（休会）
 *
 * @param planId 施設の契約中プランID
 */
export const isBasicServicePlan = (planId: number | string): boolean => {
  const normalized = normalizePlanId(planId);
  return normalized !== null && BASIC_SERVICE_PLANS.has(normalized);
}